module.exports = __webpack_public_path__ + "img/team13.477c0650.jpg";